module.exports = __webpack_public_path__ + "img/deyu_contentbox.04e22056.png";